<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="cover-container" *ngIf="cart">
    <div class="cover-content">
        <h1>Checkout</h1>
        <p class="subtitle">Revise seus dados e finalize a contratação</p>

        <!-- Resumo do Carrinho -->
        <div>
            <div class="summary-item" *ngFor="let item of cart.listService">
                <div class="summary-details">
                    <p>{{ item?.bookServiceName }}</p>
                </div>
                <p>R$ {{ item?.bookServiceValue?.toFixed(2) }}</p>
            </div>
            <div class="summary-total">
                <span>Total</span>
                <strong>R$ {{ totalBookServiceValue.toFixed(2) }}</strong>
            </div>
        </div>

        <!-- Pagamento -->
        <div class="summary">
            <h1>Pagamento</h1>
            <p class="subtitle">Escolha o método de pagamento</p>

            <!-- Métodos -->
            <mat-form-field appearance="outline">
                <mat-label>Método de pagamento</mat-label>
                <mat-select [(ngModel)]="selectedPaymentMethod" (selectionChange)="onPaymentMethodChange($event.value)">
                    <mat-option *ngFor="let method of paymentMethods" [value]="method.idPaymentMethod">
                        {{ method.paymentMethodName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Parcelamento -->
            <mat-form-field appearance="outline" *ngIf="paymentMethodInstallments.length > 0">
                <mat-label>Parcelamento</mat-label>
                <mat-select [(ngModel)]="selectedPaymentMethodInstallment">
                    <mat-option *ngFor="let installment of paymentMethodInstallments"
                        [value]="installment.idPaymentMethodInstallment">
                        {{ getInstallmentLabel(installment) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Cartão de Crédito -->
            <div *ngIf="isCreditCardFlow">
                <!-- Seleção de cartão salvo -->
                <div *ngIf="userCreditCards.length > 0" class="credit-card-select">
                    <mat-form-field appearance="outline">
                        <mat-label>Selecione um cartão salvo</mat-label>
                        <mat-select [(ngModel)]="selectedCreditCardId">
                            <mat-option *ngFor="let card of userCreditCards" [value]="card.idUserCreditCard">
                                Cartão final {{ card.lastFourDigits }} <span
                                    *ngIf="card.isPrimaryCard">(principal)</span>
                                <span *ngIf="card.paymentProcessor"> - {{ card.paymentProcessor }}</span>
                            </mat-option>
                            <mat-option [value]="null">Novo cartão</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Formulário novo cartão + endereço -->
                <div *ngIf="showNewCreditCardForm">
                    <form [formGroup]="creditCardForm" class="form-grid">
                        <mat-form-field appearance="outline">
                            <mat-label>Nome (cartão)</mat-label>
                            <input matInput formControlName="holderName">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Número do cartão</mat-label>
                            <input matInput formControlName="number">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>MM</mat-label>
                            <input matInput formControlName="expiryMonth">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>AA</mat-label>
                            <input matInput formControlName="expiryYear">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>CVC</mat-label>
                            <input matInput formControlName="ccv">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>CPF</mat-label>
                            <input matInput formControlName="cpfCnpj">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Celular</mat-label>
                            <input matInput formControlName="mobilePhone">
                        </mat-form-field>
                    </form>
                    <form [formGroup]="billingAddressForm" class="form-grid">
                        <mat-form-field appearance="outline">
                            <mat-label>CEP</mat-label>
                            <input matInput formControlName="postalCode" placeholder="00000-000">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-span-2">
                            <mat-label>Endereço</mat-label>
                            <input matInput formControlName="address">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Número</mat-label>
                            <input matInput formControlName="addressNumber">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Complemento</mat-label>
                            <input matInput formControlName="addressComplement">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Cidade</mat-label>
                            <input matInput formControlName="city">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Estado</mat-label>
                            <input matInput formControlName="state">
                        </mat-form-field>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="details-actions">
        <div class="back-btn">Voltar</div>
        <button class="continue-btn" type="button" (click)="onSubmit()" [disabled]="isLoading">Finalizar compra</button>
    </div>
</div>

<app-footer></app-footer>